import React, { useEffect, useState } from "react";
import CategoriesService from "../../services/CategoriesService";
import "./style.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import Loader from "../../common/Loader";

const Categories = () => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const { t } = useTranslation();
	const lang = useSelector((state) => state?.lang?.lang);

	useEffect(() => {
		setLoading(true);
		new CategoriesService()
			.getList()
			.then((res) => {
				if (res?.status === 200) {
					let info = res?.data?.data?.data;
					setData(info);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	}, []);

	return (
		<div className="categories-page container">
			<h5 className="type-title">{t("categories")}</h5>
			{!loading && (
				<div className="products p-0">
					<div className="row">
						{!!data?.length &&
							data?.map((category, index) => {
								return (
									<div className="col-md-3 col-12 mb-4" key={index}>
										<Card className="p-2 border-0">
											<Link
												to={`/category/${category.id}`}
												key={category?.id}
												state={category}
												style={{ textDecoration: "none" }}
												className="category-card">
												<img
													src={category?.image}
													alt="category"
													className="main-img w-100"
												/>
												<div className="information">
													<h1 className="title">
														{lang === "en"
															? category?.name_en
															: category?.name_ar}
													</h1>
												</div>
											</Link>
										</Card>
									</div>
								);
							})}
					</div>
				</div>
			)}
			{loading && <Loader />}
		</div>
	);
};

export default Categories;
